import fetch from 'isomorphic-fetch';
import { readCookie } from './common';

/**
 * s 值 : s 值 传入 true 就可自动添加S值，不传s 就不会添加s 值
 * @param params
 * @returns {Promise<PromiseLike<{json?: *, response: *}> | Promise<{json?: *, response: *}> | * | void>}
 */
let token = readCookie('userToken');// || '43c953debe3718cf5c63e2ad1b9a65c0';
let userCode = readCookie('codeid');// || 'US20170906184222042617';
// let token = readCookie('userToken'); //|| '082a5e0dd6177fb29ff8d2e05ed50ffd';
let userId = readCookie('copyrightuserId'); //|| '19315';
function appendData(object, key, value) {
	if (object && object.append) {
		object.append(key, value);
	}
}
const request = async params => {
	let { dataParam = {}, type, url, contentType, header } = params;
	let headers = new Headers(),
		paramString = '';
	// 如果是表单类型、图片类型需要自己通过 contentType描述清楚   multipart/form-data
	headers.append('Accept', 'application/json');
	//rejectUnauthorized: false
	//headers.append("rejectUnauthorized",false);
	//headers.append("token" , localStorage.getItem("token") || '');
	//headers.append('clientId', clientId || "XYD_FRONT_END_H5");
	//headers.append('clientTime', currentTime || new Date().getTime());
	if (!token) {
		token = window['userToken'];
	}
	if (!userId) {
		userId = window['copyrightuserId'];
	}
	if (token) {
		dataParam['token'] = token;
		appendData(dataParam, 'token', token);
	}
	if (userCode) {
		dataParam['userCode'] = userCode;
		appendData(dataParam, 'userCode', userCode);
	}
	if (userId) {
		// dataParam['userId'] = userId;
		appendData(dataParam, 'userId', userId);
	}
	if (contentType !== 'multipart/form-data') {
		//图片类型contentType动态生成
		headers.append('Content-Type', contentType || 'application/json;charset=utf-8');
	}
	if (header === false) {
		//调用外部api  header 为null
		headers = new Headers();
	}
	let jsonParam = {
		method: type || (type = 'GET')
		// credentials: 'include' //cookie
	};
	if (type === 'GET' || type === 'PATCH') {
		if (typeof dataParam === 'object' && dataParam) {
			paramString += '?';
			let _arr = [];
			for (let val in dataParam) {
				_arr.push(val + '=' + encodeURIComponent(dataParam[val]));
			}
			paramString += _arr.join('&');
			url = url + paramString;
		} else {
			jsonParam.body = dataParam;
		}
	} else if (contentType === 'multipart/form-data') {
		jsonParam.body = dataParam;
	} else if (contentType === 'application/x-www-form-urlencoded') {
		Object.keys(dataParam).forEach(function(val) {
			paramString += val + '=' + encodeURIComponent(dataParam[val]) + '&';
		});
		jsonParam.body = paramString;
	} else {
		jsonParam.body = JSON.stringify(dataParam);
	}
	let req = new Request(url, Object.assign(jsonParam, { headers, mode: 'cors', rejectUnauthorized: false }));
	return (
		fetch(req)
			// .then(response => {
			// 	if (response.status >= 200 && response.status < 300) {
			// 		return response;
			// 	}
			// 	const error = new Error(response.statusText);
			// 	error.response = response;
			// 	throw error;
			// })
			.then(response => {
				//会帮你做一次JSON.parse(response.text())
				return response.json().then(json => {
					return { json, response };
				});
			})
			.then(({ json, response }) => {
				let resFormatParam = {};
				resFormatParam.result = json;
				let { status, ok } = response;
				resFormatParam.status = status;
				resFormatParam.ok = ok;
				return resFormatParam;
			})
	);
};
export { request };
